import {Grid, styled, Table, TableBody, TableCell, TableRow} from "@mui/material";
import {useRecoilValue} from "recoil";
import {isAuthSelector, levelSelector, tokenSelector} from "../Recoil/Atom/authState";
import MWSkeleton from "../components/MWSkeleton";
import {useGetQuery} from "../hooks/useQueryHooks";

import AddIcon from "@mui/icons-material/Add";
import DashboardIcon from "@mui/icons-material/Dashboard";
import {Link} from "react-router-dom";
import * as boardApi from "../api/boardApi/boardApi";
import MWCaption from "../components/MWCaption";
import {ResponseList} from "../models/clientModels/interfaces/Response";
import {KPBoard} from "../models/serverModels/board/KPBoard";

const DashBoardContainer = styled(Grid)(({theme}) => ({
  width: "100%",
  paddingTop: "56px",
}));

const BoardContainer = styled(Grid)(({theme}) => ({
  // color: "rgba(0, 0, 0, 0.87)",
  transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  minWidth: "0px",
  overflowWrap: "break-word",
  backgroundColor: theme.palette.custom.main,
  backgroundClip: "border-box",
  border: "0px solid rgba(0, 0, 0, 0.125)",
  borderRadius: "1rem",
  boxShadow: "rgba(0, 0, 0, 0.05) 0rem 1.25rem 1.6875rem 0rem",
}));

const Dashboard = () => {
  const tokenState = useRecoilValue(tokenSelector);
  const userLevel = useRecoilValue(levelSelector);
  const isAuth = useRecoilValue(isAuthSelector);

  const {
    data: mainBoardList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<KPBoard>>({
    key: ["getMainBoardList", {token: tokenState}],
    api: () =>
      boardApi.getMainBoard({
        token: tokenState,
      }),
  });

  return (
    <DashBoardContainer container gap={{md: 3, lg: 4}}>
      {mainBoardList?.items.map((item) => (
        <BoardContainer item xs={12} sm={12} md={5.8} lg={5.8} key={item.uid} mb="36px">
          <MWCaption title={item.name} color="#01579B" icon={<DashboardIcon />}>
            <Link to={`/Post/${item.uid}`} className="addIcon">
              더보기
              <AddIcon />
            </Link>
          </MWCaption>
          <Table sx={{marginTop: "16px"}}>
            <TableBody>
              {isLoading && isFetching ? (
                <MWSkeleton row={5} column={2} />
              ) : (
                item.posts.map((value) => (
                  <TableRow key={value.uid}>
                    <TableCell align="left">
                      <Link to={`/Post/Read/${value.uid}`}>{value.title}</Link>
                    </TableCell>
                    <TableCell align="right">
                      {new Date(value?.entryDate).getFullYear()}년
                      {new Date(value?.entryDate).getMonth() + 1}월
                      {new Date(value?.entryDate).getDate()}일
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </BoardContainer>
      ))}
    </DashBoardContainer>
  );
};

export default Dashboard;
